import { useEffect, useState } from "react";
import CurrencySwitcher from "@/components/CurrencySwitcher";

// Slim bar sitting directly below the navbar (right-aligned, under the Sign In button).
// It is not sticky, so it scrolls away when the page scrolls; we also fade it for a clean exit.
export default function CurrencyBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="currency-bar"
      className={`border-b border-slate-200 bg-white transition-opacity duration-200 ${
        scrolled ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-end gap-2 py-0.5">
        <span className="text-xs text-slate-400">Currency</span>
        <CurrencySwitcher />
      </div>
    </div>
  );
}
